import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ServicePackageOrderService } from 'src/app/services/service-package-order.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-early-closure-dialog',
  templateUrl: './early-closure-dialog.component.html',
  styleUrls: ['./early-closure-dialog.component.scss']
})
export class EarlyClosureDialogComponent implements OnInit {

  selectedDate: Date | null = null;
  minDate: Date;
  maxDate: Date;
  
  loading = false;

  constructor(
    public dialog: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private servicePackageOrderService: ServicePackageOrderService,
    private messageService: MessageService
  ) {
    const dataFimValidade = new Date(this.config.data.dataFimValidade);
    const today = new Date();
    
    // Data mínima: amanhã
    this.minDate = new Date(today);
    this.minDate.setDate(today.getDate() + 1);
    
    // Data máxima: um dia antes da dataFimValidade
    this.maxDate = new Date(dataFimValidade);
    this.maxDate.setDate(dataFimValidade.getDate() - 1);
  }

  ngOnInit(): void {
  }

  save(): void {
    if (this.selectedDate) {
      this.loading = true;
      
      this.servicePackageOrderService.updateValidityEndDate(
        this.config.data.packageBoatId,
        this.selectedDate
      ).subscribe({
        next: () => {
          this.loading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Data de fechamento antecipada atualizada com sucesso!'
          });
          this.dialog.close(true);
        },
        error: (error) => {
          this.loading = false;
          console.error('Erro ao atualizar data de fechamento:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao atualizar data de fechamento. Tente novamente.'
          });
        }
      });
    }
  }

  close(): void {
    this.dialog.close();
  }

  isSaveDisabled(): boolean {
    return !this.selectedDate;
  }
}